module.exports = __webpack_public_path__ + "img/order_status_shouhuo@2x.f42995bd.png";